import React from 'react';
import { PropTypes as PT } from 'prop-types';
import classes from './PSTN.module.scss';

const PSTNListItem = (props) => {
  const { country, selectCountry, isHighlighted } = props;

  return (
    <button
      className={(isHighlighted) ? `${classes.listItem} ${classes.isHighlighted}` : classes.listItem}
      onClick={() => selectCountry(country)}
    >
      <span className={`flag-icon flag-icon-${country.countryCode.toLowerCase()}`} />
      <div className={classes.pstnInfo}><div>{country.countryName}</div><div>{country.phoneNumber}</div></div>
    </button>
  );
};

PSTNListItem.propTypes = {
  country: PT.object.isRequired,
  selectCountry: PT.func,
  isHighlighted: PT.bool
};

export default PSTNListItem;
